module.exports = __webpack_public_path__ + "static/img/11.96e30250.png";